import PropTypes from "prop-types";
import React from "react";
import { Button, ButtonToolbar, Form } from "react-bootstrap";
import { defineMessages, FormattedMessage } from "react-intl";

import genericTranslations from "../../../../utils/genericTranslations.js";

const messages = defineMessages({
  title: {
    id: "modules.ArriVideo.components.ContentItemForm.title",
    description: "Content item title label.",
    defaultMessage: "Title",
  },
});

const FolderForm = ({
  handleChange,
  handleSubmit,
  errors,
  values,
  onClickDelete,
  isSubmitting,
}) => {
  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group controlId="title" className="mb-3">
        <Form.Label>
          <FormattedMessage {...messages.title} />
        </Form.Label>
        <Form.Control
          type="text"
          autoComplete="off"
          value={values.title}
          onChange={handleChange}
          isInvalid={!!errors.title}
        />
        <Form.Control.Feedback type="invalid">
          {errors.title}
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group controlId="formActions" className="mb-3">
        <ButtonToolbar>
          {values.id && (
            <Button variant="danger" className="me-2" onClick={onClickDelete}>
              <FormattedMessage {...genericTranslations.delete} />
            </Button>
          )}
          <Button
            type="submit"
            disabled={isSubmitting || Object.keys(errors).length > 0}
          >
            <FormattedMessage {...genericTranslations.save} />
          </Button>
        </ButtonToolbar>
      </Form.Group>
    </Form>
  );
};

FolderForm.propTypes = {
  handleChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  onClickDelete: PropTypes.func.isRequired,
  errors: PropTypes.shape({
    title: PropTypes.string,
  }),
  values: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
  }).isRequired,
};

export default FolderForm;
